export {default} from './content-editable.vue'